"use client";

import { CardBlock as CardBlockProps } from "@/payload-types";
import { Media } from "@onclicks/sharedcomponents/Media/Media";
import RichText from "../components/RichText";

export const CardBlock: React.FC<CardBlockProps> = ({
  title,
  content,
  backgroundMedia,
  backgroundMediaHover,
}) => {
  return (
    <div className="relative overflow-hidden h-screen w-full group bg-linear-to-t from-black/90 via-black/30 to-transparent">
      {backgroundMedia && typeof backgroundMedia !== "string" && (
        <div
          className={`absolute inset-0 z-0 w-full h-full transition-opacity duration-500 ${backgroundMediaHover ? "group-hover:opacity-0" : "opacity-100"}`}
        >
          <Media
            resource={backgroundMedia}
            fill
            imgClassName="object-cover w-full h-full"
            videoClassName="object-cover w-full h-full"
          />
        </div>
      )}

      {backgroundMediaHover && typeof backgroundMediaHover !== "string" && (
        <div className="absolute inset-0 z-0 w-full h-full opacity-0 group-hover:opacity-100 transition-opacity duration-500">
          <Media
            resource={backgroundMediaHover}
            fill
            imgClassName="object-cover w-full h-full"
            videoClassName="object-cover w-full h-full"
          />
        </div>
      )}

      {/* texte */}
      <div
        className="
          absolute inset-0 z-10 
          flex flex-col
          md:p-6 
          w-[65%]
          mx-auto
          justify-end
          text-center
          text-white"
      >
        <div className="px-2 pt-2 backdrop-brightness-50 transition-all duration-300 rounded shadow-2xl">
          {title && (
            <h2
              className={`
                text-2xl!
                lg:text-3xl!
                mb-5
                leading-tight
            `}
            >
              {title}
            </h2>
          )}
          {content && (
            <div>
              <RichText
                data={content}
                enableGutter={false}
                enableProse={false}
                className={`text-white text-base md:text-lg`}
              />
            </div>
          )}
          <span className="block mt-5 mb-8 h-px w-40 md:w-32 mx-auto bg-white/60" />
        </div>
      </div>
    </div>
  );
};
